import { useEffect } from 'react';

export const useHandleOpenGraph = ({
  title,
  description,
  url,
  imageUrl,
} = defaultMetaTag) => {
  const ogAttributeHandler = ({ og, content }) => {
    document
      .querySelector(`meta[property="og:${og}"]`)
      .setAttribute('content', content);
  };

  useEffect(() => {
    title && ogAttributeHandler({ og: 'title', content: title });
    description &&
      ogAttributeHandler({ og: 'description', content: description });
    imageUrl && ogAttributeHandler({ og: 'image', content: imageUrl });
    url && ogAttributeHandler({ og: 'url', content: url });

    return () => {
      ogAttributeHandler({ og: 'title', content: defaultMetaTag.title });
      ogAttributeHandler({
        og: 'description',
        content: defaultMetaTag.description,
      });
      ogAttributeHandler({ og: 'image', content: defaultMetaTag.imageUrl });
      ogAttributeHandler({ og: 'url', content: defaultMetaTag.url });
    };
  }, []);
};

const defaultMetaTag = {
  title: '베이비페이스(BABYFACE)',
  description:
    '우리 아기 첫 사진, 베이비페이스. 입체초음파를 AI로 분석하여 생후 50일 아기 얼굴을 예측해주는 서비스입니다',
  imageUrl: 'https://cafvifwe10507.edge.naverncp.com/thumbnail_new.png',
  url: 'https://www.babyface.io/',
};
